import React, { useState } from 'react'

import firebase from 'gatsby-plugin-firebase'

import ButtonAppleStore from '~/assets/app_store.svg'
// import ButtonGooglePlay from '~/assets/google_play.svg'
import FacebookFormDialog from '~/components/common/FacebookFormDialog'
import SectionSubtitle from '~/components/sections/SectionSubtitle'
import SectionTitle from '~/components/sections/SectionTitle'
import ButtonGooglePlay from '~/images/google_play.png'
import translate from '~/locale'

import { StoreButtons, StyledContainer, StyledSection } from './styles'

const Download: React.FC = () => {
  const [facebookFormDialogOpen, setFacebookFormDialogOpen] = useState<boolean>(
    false,
  )

  const handleDownloadClick = (store: string) => {
    firebase.analytics().logEvent('download', {
      store,
    })
  }

  return (
    <StyledSection id="download">
      <StyledContainer>
        <SectionTitle color="white">
          {translate('see_residents_in_action')}
        </SectionTitle>
        <SectionSubtitle color="white">
          {translate('discover the power')}
        </SectionSubtitle>

        <StoreButtons>
          <a
            className="link-download"
            href="https://apps.apple.com/us/app/resident/id1547782698"
            target="_blank"
            rel="noreferrer"
            onClick={() => handleDownloadClick('apple')}
          >
            <ButtonAppleStore className="appleBtn" />
          </a>
          <a
            className="link-download"
            href="https://play.google.com/store/apps/details?id=io.baseline.resident"
            target="_blank"
            rel="noreferrer"
            onClick={() => handleDownloadClick('google')}
          >
            <img src={ButtonGooglePlay} className="googleBtn" />
          </a>
          <FacebookFormDialog
            open={facebookFormDialogOpen}
            onClose={() => setFacebookFormDialogOpen(false)}
          />
        </StoreButtons>
      </StyledContainer>
    </StyledSection>
  )
}

export default Download
